import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"
import SButton from "components/Common/Button"
import TableContainer from "components/newTables/TableContainer"

const Table = ({ content, page, size, count, setParams, params }) => {
  const history = useHistory()
  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      id: v.id,
      companyName: v.companyName,
      bunch: v.bunch,
      brand: v.brand,
      number: v.number,
      mixedRatio: v.mixedRatio,
      clothWidth: v.clothWidth,
      latestUnitPrice: v.latestUnitPrice,
      outOfStock: v.outOfStock,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "生地商社名",
        accessor: "companyName",
        disableSortBy: true,
      },
      {
        Header: "バンチ",
        accessor: "bunch",
        disableSortBy: true,
      },
      {
        Header: "ブランド",
        accessor: "brand",
        disableSortBy: true,
      },
      {
        Header: "生地番号",
        accessor: "number",
        disableSortBy: true,
      },
      {
        Header: "混率",
        accessor: "mixedRatio",
        disableSortBy: true,
      },
      {
        Header: "生地巾",
        accessor: "clothWidth",
        disableSortBy: true,
      },
      {
        Header: "最新生地単価",
        accessor: "latestUnitPrice",
        disableSortBy: true,
      },
      {
        Header: "品切れ",
        accessor: "outOfStock",
        disableSortBy: true,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(`/master/dough/${cell.row.original.id}`)
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      page={page}
      size={size}
      count={count}
      params={params}
      setParams={setParams}
      columns={columns}
      data={listDataTable}
      pagination
    />
  )
}

export default Table
